var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.488,
    height: 49.678,
    viewBox: "0 0 36.488 49.678",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4842",
    "data-name": "Group 4842",
    transform: "translate(-484.512 -867)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3428",
    "data-name": "Path 3428",
    d: "M0,0H36.488V49.678L18.244,44.731,0,49.678Z",
    transform: "translate(484.512 867)",
    fill: "#ffc629"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4800",
    "data-name": "Group 4800",
    transform: "translate(487.553 877.59)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4790",
    "data-name": "Group 4790",
    transform: "translate(22.395 11.599)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3429",
    "data-name": "Path 3429",
    d: "M658.923,571.724a.673.673,0,0,1-.256-1.295,4.14,4.14,0,0,0,1.8-1.893,3.239,3.239,0,0,0-2.037-.136,4.854,4.854,0,0,0-2.805,2.481.673.673,0,0,1-1.17-.665,6.148,6.148,0,0,1,3.627-3.116,4.72,4.72,0,0,1,3.667.568.673.673,0,0,1,.249.906c-.833,1.507-1.63,2.611-2.815,3.1A.681.681,0,0,1,658.923,571.724Z",
    transform: "translate(-654.364 -566.948)",
    fill: "#1d1d1d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4791",
    "data-name": "Group 4791",
    transform: "translate(19.159 16.093)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3430",
    "data-name": "Path 3430",
    d: "M652.16,580c-.069,0-.138,0-.208-.005a5.332,5.332,0,0,1-3.394-1.65.673.673,0,0,1-.022-.951,6.231,6.231,0,0,1,4.03-2.086,5.044,5.044,0,0,1,3.892,1.5.672.672,0,0,1,.022.95A6.124,6.124,0,0,1,652.16,580Zm-2.135-2.166a3.6,3.6,0,0,0,1.995.817,4.206,4.206,0,0,0,2.97-1.321,3.545,3.545,0,0,0-2.331-.68A4.572,4.572,0,0,0,650.025,577.836Z",
    transform: "translate(-648.351 -575.298)",
    fill: "#1d1d1d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4792",
    "data-name": "Group 4792",
    transform: "translate(24.077 5.77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3431",
    "data-name": "Path 3431",
    d: "M658.162,562.385h-.045a.673.673,0,0,1-.626-.716c.234-3.522,2.532-5.755,5.7-5.535a.672.672,0,0,1,.626.716c-.148,2.234-.878,3.823-2.17,4.72a.673.673,0,0,1-.767-1.1,4.152,4.152,0,0,0,1.521-2.985c-2.055.17-3.4,1.751-3.567,4.278A.673.673,0,0,1,658.162,562.385Z",
    transform: "translate(-657.489 -556.117)",
    fill: "#1d1d1d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4793",
    "data-name": "Group 4793",
    transform: "translate(23.58 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3432",
    "data-name": "Path 3432",
    d: "M657.583,553.143a.673.673,0,0,1-.64-.466c-1.084-3.359.223-6.273,3.251-7.249a.672.672,0,0,1,.847.434c.688,2.135.6,3.883-.277,5.195a.673.673,0,1,1-1.12-.745,4.152,4.152,0,0,0,.314-3.34c-1.846.917-2.512,2.883-1.734,5.293a.674.674,0,0,1-.64.879Z",
    transform: "translate(-656.566 -545.395)",
    fill: "#1d1d1d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4794",
    "data-name": "Group 4794",
    transform: "translate(0.297 11.599)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3433",
    "data-name": "Path 3433",
    d: "M616.457,571.724a.685.685,0,0,1-.256-.05c-1.185-.488-1.982-1.592-2.815-3.1a.673.673,0,0,1,.249-.906,4.715,4.715,0,0,1,3.667-.568,6.147,6.147,0,0,1,3.627,3.116.673.673,0,0,1-1.17.665,4.853,4.853,0,0,0-2.8-2.482,3.238,3.238,0,0,0-2.037.136,4.138,4.138,0,0,0,1.8,1.893.673.673,0,0,1-.256,1.295Z",
    transform: "translate(-613.302 -566.948)",
    fill: "#1d1d1d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4795",
    "data-name": "Group 4795",
    transform: "translate(2.931 16.093)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3434",
    "data-name": "Path 3434",
    d: "M622.7,580a6.125,6.125,0,0,1-4.321-2.246.672.672,0,0,1,.022-.95,5.042,5.042,0,0,1,3.892-1.5,6.23,6.23,0,0,1,4.03,2.086.673.673,0,0,1-.021.951,5.332,5.332,0,0,1-3.394,1.65C622.842,580,622.773,580,622.7,580Zm-2.829-2.67a4.211,4.211,0,0,0,2.97,1.321,3.6,3.6,0,0,0,1.994-.817,4.573,4.573,0,0,0-2.633-1.184A3.559,3.559,0,0,0,619.874,577.332Z",
    transform: "translate(-618.196 -575.298)",
    fill: "#1d1d1d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4796",
    "data-name": "Group 4796",
    transform: "translate(0 5.771)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3435",
    "data-name": "Path 3435",
    d: "M618.406,562.386a.673.673,0,0,1-.671-.628c-.168-2.527-1.513-4.109-3.568-4.278a4.152,4.152,0,0,0,1.521,2.985.673.673,0,0,1-.768,1.1c-1.292-.9-2.022-2.485-2.17-4.72a.672.672,0,0,1,.626-.716c3.166-.212,5.466,2.013,5.7,5.535a.673.673,0,0,1-.627.716Z",
    transform: "translate(-612.75 -556.119)",
    fill: "#1d1d1d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4797",
    "data-name": "Group 4797",
    transform: "translate(1.897 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3436",
    "data-name": "Path 3436",
    d: "M620.187,553.143a.68.68,0,0,1-.207-.033.673.673,0,0,1-.434-.846c.778-2.41.112-4.377-1.734-5.293a4.152,4.152,0,0,0,.314,3.34.673.673,0,1,1-1.12.745c-.872-1.312-.965-3.06-.277-5.195a.672.672,0,0,1,.846-.434c3.028.977,4.335,3.891,3.251,7.249A.673.673,0,0,1,620.187,553.143Z",
    transform: "translate(-616.275 -545.395)",
    fill: "#1d1d1d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4798",
    "data-name": "Group 4798",
    transform: "translate(7.581 1.895)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3437",
    "data-name": "Path 3437",
    d: "M634.459,564.161a7.622,7.622,0,1,1,7.622-7.622A7.63,7.63,0,0,1,634.459,564.161Zm0-13.9a6.277,6.277,0,1,0,6.277,6.277A6.284,6.284,0,0,0,634.459,550.262Z",
    transform: "translate(-626.837 -548.917)",
    fill: "#1d1d1d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4799",
    "data-name": "Group 4799",
    transform: "translate(10.642 4.756)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3438",
    "data-name": "Path 3438",
    d: "M639.489,562.975a.68.68,0,0,1-.274-.059l-2.129-.95-2.129.95a.672.672,0,0,1-.939-.721l.354-2.2-1.669-1.807a.673.673,0,0,1,.419-1.125l2.287-.259,1.073-2.192a.672.672,0,0,1,1.209,0l1.073,2.192,2.287.259a.673.673,0,0,1,.419,1.125l-1.669,1.807.354,2.2a.673.673,0,0,1-.664.78Zm-2.4-2.419a.675.675,0,0,1,.274.059l1.267.566-.208-1.3a.671.671,0,0,1,.17-.563l.99-1.072-1.335-.151a.673.673,0,0,1-.528-.373l-.63-1.289-.63,1.289a.673.673,0,0,1-.529.373l-1.335.151.99,1.072a.67.67,0,0,1,.17.563l-.208,1.3,1.267-.566A.676.676,0,0,1,637.086,560.556Z",
    transform: "translate(-632.524 -554.232)",
    fill: "#1d1d1d"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.5581c1f83e3e4f383bc9655afba97aea.svg";
export { ForwardRef as ReactComponent };